import {
  AiFillHeart,
  AiFillMessage,
  AiFillPhone,
  AiFillSafetyCertificate,
  AiOutlineClose,
  AiOutlineHeart,
} from "react-icons/ai";
import { BiArrowBack, BiSprayCan, BiTimeFive } from "react-icons/bi";
import { BsBag, BsCardText } from "react-icons/bs";
import {
  FaCarSide,
  FaCheck,
  FaEdit,
  FaExclamationCircle,
  FaFileImage,
  FaInfo,
  FaMapMarkerAlt,
  FaPlus,
  FaStar,
  FaUserTie,
} from "react-icons/fa";
import {
  FiAlertTriangle,
  FiBell,
  FiBookmark,
  FiBookOpen,
  FiChevronRight,
  FiClock,
  FiCreditCard,
  FiFileText,
  FiHome,
  FiLock,
  FiLogIn,
  FiLogOut,
  FiMapPin,
  FiTrash2,
  FiUser,
} from "react-icons/fi";
import { GoCalendar, GoPaperclip } from "react-icons/go";
import { GrDislike, GrLike } from "react-icons/gr";
import { HiOutlineDocumentDownload } from "react-icons/hi";
import type { IconBaseProps } from "react-icons/lib";
import {
  MdArrowDownward,
  MdArrowForwardIos,
  MdArrowUpward,
  MdCampaign,
  MdHelp,
  MdPlace,
  MdTrain,
} from "react-icons/md";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { RiAlarmWarningLine, RiMoneyCnyCircleLine } from "react-icons/ri";
import { TbAdjustmentsHorizontal, TbLicense } from "react-icons/tb";

type Props = {} & IconBaseProps;

const iconDefaultOption = {
  size: "1rem",
};

export function CheckIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaCheck {...option} />;
}

export function ExclamationCircleIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaExclamationCircle {...option} />;
}

export function SprayCanIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BiSprayCan {...option} />;
}

export function TimeFiveIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BiTimeFive {...option} />;
}

export function PlaceIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdPlace {...option} />;
}

export function MoneyIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <RiMoneyCnyCircleLine {...option} />;
}

export function TrainIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdTrain {...option} />;
}

export function LicenseIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <TbLicense {...option} />;
}

export function BagIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsBag {...option} />;
}

export function ProfileIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsCardText {...option} />;
}

export function AttentionIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <RiAlarmWarningLine {...option} />;
}

export function InfoIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaInfo {...option} />;
}

export function ArrowForwardIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdArrowForwardIos {...option} />;
}

export function ArrowBackIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BiArrowBack {...option} />;
}

export function ArrowUpIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdArrowUpward {...option} />;
}

export function ArrowDownIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdArrowDownward {...option} />;
}

export function SafetyCertificateIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <AiFillSafetyCertificate {...option} />;
}

export function HeartIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <AiFillHeart {...option} />;
}

export function HeartOutlineIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <AiOutlineHeart {...option} />;
}

export function LikeIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <GrLike {...option} />;
}

export function DisLikeIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <GrDislike {...option} />;
}

export function MarkerIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaMapMarkerAlt {...option} />;
}

export function PhoneIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <AiFillPhone {...option} />;
}

export function CloseIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <AiOutlineClose {...option} />;
}

export function StarIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaStar {...option} />;
}

export function PlusIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaPlus {...option} />;
}

export function TrashIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiTrash2 {...option} />;
}

export function HelpIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdHelp {...option} />;
}

export function EditIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaEdit {...option} />;
}

export function CarIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaCarSide {...option} />;
}

export function UserTieIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaUserTie {...option} />;
}

export function OfficeIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <PiBuildingOfficeLight {...option} />;
}

export function CampaignIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdCampaign {...option} />;
}

export function BookmarkIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiBookmark {...option} />;
}

export function BellIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiBell {...option} />;
}

export function ClockIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiClock {...option} />;
}

export function MapPinIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiMapPin {...option} />;
}

export function CalendarIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <GoCalendar {...option} />;
}

export function AdjustmentsHorizontalIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <TbAdjustmentsHorizontal {...option} />;
}

export function MessageIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <AiFillMessage {...option} />;
}

export function FileImageIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaFileImage {...option} />;
}

export function PaperClipIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <GoPaperclip {...option} />;
}

export function DocumentDownloadIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <HiOutlineDocumentDownload {...option} />;
}

export function AlertTriangleIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiAlertTriangle {...option} />;
}

export function ChevronRightIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiChevronRight {...option} />;
}

export function LogInIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiLogIn {...option} />;
}

export function LogOutIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiLogOut {...option} />;
}

export function UserIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiUser {...option} />;
}

export function CreditCardIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiCreditCard {...option} />;
}

export function FileTextIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiFileText {...option} />;
}

export function HomeIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiHome {...option} />;
}

export function LockIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiLock {...option} />;
}

export function BookOpenIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FiBookOpen {...option} />;
}
